export const webClientId = '259698511927-srs8v0m5m7do92rgpvlnsnqie3mlbgtu.apps.googleusercontent.com'